import http from 'plugins/axios';

export default {
  createTask(data) {
    return http.post({
      url: '/la/admin/dividend/task/create',
      data,
      dataType: 'form'
    });
  },
  updateTask(data) {
    return http.post({
      url: '/la/admin/dividend/task/update',
      data,
      dataType: 'form'
    });
  },
  removeTask(id) {
    return http.post({
      url: '/la/admin/dividend/task/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  executeTask(id) {
    return http.post({
      url: '/la/admin/dividend/task/execute',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  listTasks(data) {
    return http.get({
      url: '/la/admin/dividend/task/list',
      data
    });
  },
  updateProfit(data) {
    return http.post({
      url: '/la/admin/dividend/profit/update',
      data,
      dataType: 'form'
    });
  },
  getProfit() {
    return http.get({
      url: '/la/admin/dividend/profit'
    });
  },
  getTaskDetail(id) {
    return http.get({
      url: '/la/admin/dividend/task/detail',
      data: {
        id
      }
    });
  },
  listRecords(data) {
    return http.get({
      url: '/la/admin/dividend/record/list',
      data
    });
  },
  billTask(data) {
    return http.post({
      url: '/la/admin/dividend/record/execute',
      data,
      dataType: 'form'
    });
  },
  executeRecord(id) {
    return http.post({
      url: '/la/admin/dividend/record/execute',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  executeAllRecords(taskId) {
    return http.post({
      url: '/la/admin/dividend/record/execute/all',
      data: {
        taskId
      },
      dataType: 'form'
    });
  }
};
